export default __webpack_public_path__ + "static/media/OvalRight.c662b293.png";